import { css } from "styled-components"
import { blueEllipseGradient, colors } from "../../helpers/colors"
import { fonts } from "../../helpers/fonts"
import diamond from "../../assets/diamond.png"

export const NavBarWrapperStyles = css`
  position: relative;
  margin: 0 22px;
  height: 60px;
  &:before {
    display: block;
    content: "";
    position: absolute;
    height: 100%;
    width: 22px;
    top: 0;
    left: -21px;
    background: linear-gradient(
      ${colors.blueGradientStart} 0%,
      ${colors.blueGradientEnd} 100%
    );
    clip-path: polygon(0 0, 100% 0, 100% 100%);
  }
`

export const NavBarInnerStyles = css`
  height: 60px;
  justify-content: space-between;
  width: 100%;
  background: linear-gradient(
    ${colors.blueGradientStart} 0%,
    ${colors.blueGradientEnd} 100%
  );
`

export const RowStyles = css``

export const ButtonsWrapperStyles = css`
  & > .btn {
    border: 0;
    padding-left: 30px;
    padding-right: 30px;
    margin-right: -22px;
    clip-path: polygon(100% 0, 22px 0, 0 100%, calc(100% - 22px) 100%);
  }
  & > .btn.primary {
    font-size: ${fonts.sizes[3]};
  }
  & > .btn.secondary {
    font-size: ${fonts.sizes[2]};
    color: ${colors.goldGradientStart};
    &:hover {
      ${blueEllipseGradient}
    }
    &:before {
      content: "";
      background-image: url(${diamond});
      width: 25px;
      height: 25px;
      margin-right: 11px;
    }
  }
`

export const LogoImgStyle = {
  objectFit: "contain",
  height: "91px",
  width: "154px",
}

export const LogoStyle = {
  marginTop: "-15px",
  marginLeft: "22px",
  height: "91px",
  width: "154px",
}
